var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:[
    _vm.$style.root,
    ( _obj = {}, _obj[_vm.$style.vertical] = _vm.vertical, _obj ) ]},[_c('div',{class:_vm.$style.title},[_vm._v(" "+_vm._s(_vm.title)),(_vm.required)?_c('span',[_vm._v("*")]):_vm._e()]),_c('div',{class:_vm.$style.slot},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }